import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useLang } from "../../lib/LangContext";
import { URL_LANGS, langToUrl, localizedPath, preferredLang, splitPath, urlToLang } from "../../lib/i18nRoutes";
import NotFound from "../../pages/NotFound";

// Old unprefixed URL (/, /arbeiten, …) → same page in the preferred language.
export const LegacyRedirect = () => {
  const { pathname, search, hash } = useLocation();
  return <Navigate replace to={{ pathname: localizedPath(preferredLang(), pathname), search, hash }} />;
};

// /:lng/* — validates the prefix, syncs it into the language context and
// moves to the equivalent URL when the visitor explicitly switches language.
export const LocaleLayout = ({ shell: Shell }) => {
  const { lng } = useParams();
  const { lang, syncLang, choiceVersion } = useLang();
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();
  const valid = URL_LANGS.includes(lng);

  useEffect(() => {
    if (valid) syncLang(urlToLang(lng));
  }, [lng, valid, syncLang]);

  useEffect(() => {
    if (!choiceVersion || !valid || langToUrl(lang) === lng) return;
    const { rest } = splitPath(pathname);
    navigate({ pathname: localizedPath(lang, rest), search, hash });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [choiceVersion]);

  if (!valid) return <Shell><NotFound /></Shell>;
  return <Outlet />;
};

export const useLocalePath = () => {
  const { lang } = useLang();
  return (path = "/") => localizedPath(lang, path);
};
